import React from "react";
import "../css/Servicios.css";

const Servicios = () => {
    const servicios = [
        {
            icon: "fa-code",
            titulo: "Desarrollo",
            descripcion: "Software moderno y automatización empresarial.",
        },
        {
            icon: "fa-mobile-screen-button",
            titulo: "Apps",
            descripcion: "Aplicaciones Android y iOS de alto impacto.",
        },
        {
            icon: "fa-globe",
            titulo: "Web",
            descripcion: "Sitios web rápidos, modernos y escalables.",
        },
        {
            icon: "fa-cloud",
            titulo: "Integraciones",
            descripcion: "Conectamos plataformas y APIs empresariales.",
        },
        {
            icon: "fa-headset",
            titulo: "Soporte IT",
            descripcion: "Acompañamiento técnico continuo y seguro.",
        },
        {
            icon: "fa-graduation-cap",
            titulo: "Capacitación",
            descripcion: "Entrenamiento tecnológico para equipos.",
        },
    ];

    return (
        <section className="servicios-section">
            <div className="container">

                {/* HEADER */}
                <div className="servicios-header text-center">
                    <span className="badge-servicios">
                        <i className="fa-solid fa-sparkles"></i>
                        SERVICIOS TECNOLÓGICOS
                    </span>

                    <h2 className="titulo-servicios">
                        Soluciones que hacen
                        <span> crecer tu negocio</span>
                    </h2>

                    <p className="subtitulo-servicios">
                        Tecnología moderna enfocada en resultados reales.
                    </p>
                </div>

                {/* GRID */}
                <div className="row g-4">

                    {servicios.map((servicio, index) => (
                        <div className="col-lg-4 col-md-6" key={index}>

                            <div className="servicio-card">

                                {/* ICONO */}
                                <div className="icono-box">
                                    <i className={`fa-solid ${servicio.icon}`}></i>
                                </div>

                                {/* TITULO */}
                                <h3>{servicio.titulo}</h3>

                                {/* DESCRIPCION */}
                                <p>{servicio.descripcion}</p>

                                {/* LINEA */}
                                <div className="linea"></div>

                                {/* BOTON */}
                                <button className="btn-servicio">
                                    Ver más
                                    <i className="fa-solid fa-arrow-right"></i>
                                </button>

                            </div>

                        </div>
                    ))}

                </div>
            </div>
        </section>
    );
};

export default Servicios;